// Global helpers //
let domItems = {};
window.helpers = {
  addItemToCart: async (productId, quantity = 1, refresh = false) => {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: productId,
              quantity: quantity,
            },
          ],
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const cartItems = await response.json();

      if (refresh) {
        helpers.getCart().then((cart) => {
          helpers.refreshCart(cart);
          helpers.showMiniCart();
        });
      }

      return cartItems;
    } catch (error) {
      console.error("Error adding item to cart:", error);
      return null;
    }
  },
  getCart: async () => {
    return fetch("/cart.js")
      .then((response) => response.json())
      .then((cartItems) => {
        return cartItems;
      })
      .catch((error) => {
        console.error("Error fetching cart items:", error);
        return null;
      });
  },
  getCartItems: async () => {
    return getCart().then((cart) => cart.items);
  },
  hideMiniCart: () => {
    const cartContainer = document.querySelector(".cart_container");
    if (cartContainer) {
      cartContainer.classList.remove("active_link");
    }
  },
  restructureMiniCartItems: async () => {
    // Mini cart items should have this structure.
    /* 
       -- Regular cart items -- 
        li.cart_item.clearfix
          div.cart_image
          div.cart_item__title
            div.item_title
            div.left.product-quantity-box
          strong.right.price
        -- Bundle cart items --
        li.cart_item.clearfix
          div.cart_image
          div.cart_item__title
            div.item_title
            div.left.product-quantity-box
          style
          div.bundle-wrapper-main
          strong.right.price
    */
    setTimeout(() => {
      domItems.cartItems = document.querySelectorAll(".cart_item");
      domItems.cartItems.forEach((item) => {
        const itemImage = item.querySelector(".cart_image");
        const itemTitleContainer = item.querySelector(".cart_item__title");
        const itemPrice = item.querySelector("strong");
        const fadedItem = item.classList.contains("fadeOutUp");
        const bundleSpace = item.querySelector(".bundle-space");

        if (fadedItem) {
          item.remove();
          return;
        }

        if (
          !item.classList.contains("bundle-item") &&
          !item.classList.contains("bundle_cart_item")
        ) {
          item.innerHTML = "";
          itemImage && item.appendChild(itemImage);
          itemTitleContainer && item.appendChild(itemTitleContainer);
          itemPrice && item.appendChild(itemPrice);
        } else {
          const itemQuantityBox = item.querySelector(".product-quantity-box");
          const itemTitle = item.querySelector(".item_title");

          itemTitle?.after(itemQuantityBox);
          helpers.getCart().then((cart) => {
            const formattedPrice = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(cart.total_price / 100);
            const cartSubtotal = document.querySelector(
              ".js-cart_subtotal .money"
            );
            if (cartSubtotal) {
              cartSubtotal.innerHTML = formattedPrice;
            }
          });
          itemQuantityBox && (itemQuantityBox.style.display = "flex");
        }
        bundleSpace && (bundleSpace.style.display = "none");
      });
    }, 250);
  },
  showMiniCart: () => {
    const cartContainer = document.querySelector(".cart_container");
    if (cartContainer) {
      cartContainer.classList.add("active_link");
    }
  },
  updateMinicart: (show = false) => {
    helpers.getCart().then((cart) => {
      helpers.refreshCart(cart);
      if (show) {
        helpers.showMiniCart();
      }
    });
  },
};
